import { Component, Input } from '@angular/core';

type SvgIconVariant = 'default' | 'danger' | 'success' | 'warning' | 'secondary' | 'info' | 'primary-green';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss']
})
export class SvgIconComponent {
  @Input() public name = '';
  @Input() public size = 30;
  @Input() public width?: number;
  @Input() public height?: number;
  @Input() public variant: SvgIconVariant = 'default';
  @Input() public secondaryColor = '#000000';
  @Input() public secondaryOpacity = 0.37;

  private readonly variantColorMap: Record<SvgIconVariant, string> = {
    default: 'rgba(1, 24, 98, 1)',
    danger: 'rgba(209, 38, 38, 1)',
    success: 'rgba(16, 196, 105, 1)',
    warning: 'rgba(235, 195, 32, 1)',
    secondary: 'rgba(89, 74, 12, 1)',
    info: 'rgba(33, 150, 243, 1)',
    'primary-green': 'rgba(58, 182, 62, 1)'
  };

  public get iconWidth(): number {
    return this.width ?? this.size;
  }

  public get iconHeight(): number {
    return this.height ?? this.size;
  }

  public get iconColor(): string {
    return this.variantColorMap[this.variant] ?? this.variantColorMap.default;
  }
}
